import Rellax, { RellaxInstance, RellaxOptions } from 'rellax';
import { throttle } from 'throttle-debounce';

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="block-media-small"]';

/**
 * Friendation component
 */
export const blockMediaSmall = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    /**
     * Behaviour for Image
     */
    const handleImage = () => {
      const imageEl = component.querySelector('.image');
      if (!imageEl) return;

      /** Rellax instance */
      let rellax: RellaxInstance;

      /** Returns `true` if mobile is detected */
      const isMobile = () => window.matchMedia('(max-width: 1280px)').matches;

      /** Returns `true` if reduced motion is preferred */
      const prefersReducedMotion = () =>
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /**
       * Destroy the rellax instance {@link rellax}
       */
      const destroy = () => {
        if (rellax) {
          rellax.destroy();
          rellax = undefined;
        }
      };

      const options: RellaxOptions = {
        speed: 1,
        center: true
      };

      /**
       * Set or destroy parallax effect based on {@link isMobile}
       */
      const setParallax = () => {
        if (isMobile() || prefersReducedMotion()) {
          destroy();
        } else {
          if (rellax) {
            rellax.refresh();
          } else {
            if (!isMobile()) {
              setTimeout(() => {
                rellax = new Rellax(imageEl, options);
              }, 100);
            }
          }
        }
      };

      const onResize = throttle(100, () => {
        setParallax();
      });

      /** Listen for resize */
      window.addEventListener('resize', onResize);

      const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      /** Listen for reduced motion settings changed on device */
      mediaQuery.addEventListener('change', () => {
        setParallax();
      });

      /** Run on load */
      setParallax();
    };

    /** This component can do either video oder image. We only need JavaScript for the video variant. */
    if (!component.querySelector('.media-inner--video')) {
      handleImage();
    }
  });
};
